module.exports = __webpack_public_path__ + "img/number_hover.42f71561.png";